<template>
  <badge :type="getBadgeType()">
    {{ $t(`STOCK_MOVEMENTS.STATUS_${stockMovement.status}`) }}
  </badge>
</template>

<script>
import {
  deliveriesStatusesOption,
  DELIVERY_STATUS_DRAFT,
  DELIVERY_STATUS_VALIDATED,
  DELIVERY_STATUS_CANCELED,
} from "@/constants/deliveries";

export default {
  name: "stock-movement-status-badge",

  components: {},

  mixins: [],

  props: ["stockMovement"],

  data() {
    return {
      statusesOptions: deliveriesStatusesOption,
    };
  },

  computed: {},

  methods: {
    getBadgeType() {
      switch (this.stockMovement.status) {
        case DELIVERY_STATUS_DRAFT:
          return "primary";
        case DELIVERY_STATUS_VALIDATED:
          return "success";
        case DELIVERY_STATUS_CANCELED:
          return "danger";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
